import React from "react";
import DashboardOrdemServico from "../../components/PortalHome/DashboardOS";

import "./style.css"
import DashboardTeste from "../../components/PortalHome/DashboardOS/DashBoardTeste";


// fazer uma lógica para trazer as OS apenas do paralegal quando o perfil por PARALEGAL - FEITO (Fiz uma lógica para o usuário escolher a quantidade de OS escolher o tipo se PARALEGAL ou CONTADOR)
// filtro id de usuário que está com problemas - FEITO

// as canceladas não deve aparecer para o Gleidson
// subtrair ativas e finalizadas paralegal - FEITO

// quando chegar na junta comercial colocar procuração ECAC (novo doc na lista) - FEITO

// editar observação na OS - FEITO

function PageDashboard() {

  return (
    <>
      <div className="centralizar">
        <DashboardOrdemServico />
      </div>
    </>
  );
}
export default PageDashboard;
